import { useContext, useCallback } from 'react';
import _get from 'lodash/get';
import _find from 'lodash/find';
import { AjaxContext, AppContext, UserContext, formatListData } from 'commons-ui';
import { PAGE_NAMES, BULK_ACTIONS_RESOURCES, ACTION } from 'constant';
import { BulkReplyFilters } from './constants';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const {
		app: { appName }
	} = useContext(AppContext);
	const { permissionsConfig } = useContext(UserContext);
	const listBulkReply = useCallback(async (filters: BulkReplyFilters | undefined) => {
		const permission = _find(permissionsConfig, { actionName: ACTION.listBulkReply });
		const result = await postData({
			endpoint: `/dashboard/listBulkReply/${PAGE_NAMES.bulkActions}-${BULK_ACTIONS_RESOURCES.bulkReply}-listBulkReply`,
			queryParams: {
				appName
			},
			body: {
				startDate: filters?.from,
				endDate: filters?.to
			},
			customHeaders: {
				isMasked: permission?.isMasked || false
			}
		});
		return {
			rowCount: _get(result, ['data', 'totalCount'], 0),
			data: formatListData(_get(result, ['data', 'data'], []))
		};
	}, []);

	const executeBulkReply = useCallback((data: any) => {
		const permission = _find(permissionsConfig, { actionName: ACTION.executeBulkReply });
		return postData({
			endpoint: `/dashboard/executeBulkReply/${PAGE_NAMES.bulkActions}-${BULK_ACTIONS_RESOURCES.bulkReply}-executeBulkReply`,
			body: { ...data },
			queryParams: {
				appName
			},
			customHeaders: {
				isMasked: permission?.isMasked || false
			}
		});
	}, []);

	return {
		listBulkReply,
		executeBulkReply
	};
};

export default useService;
